module.exports = __webpack_public_path__ + "static/fonts/iconfont.8e87ef03.woff";